import { render, staticRenderFns } from "./BranchesCreateOrEdit.vue?vue&type=template&id=968b1efc&"
import script from "./BranchesCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./BranchesCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports